import { createApp } from 'vue'
import App from './App.vue'
import router from '../router.config.js'
import axios from 'axios'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import CKEditor from '@ckeditor/ckeditor5-vue';


import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

//创建vue实例
const app = createApp(App)

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}

//创建pinia实例，并挂载到vue实例上
const pinia = createPinia()
//使用pinia-plugin-persistedstate持久化存储
pinia.use(piniaPluginPersistedstate)
app.config.globalProperties.$pinia = pinia;

// 设置baseURL
axios.defaults.baseURL = '/';
axios.defaults.withCredentials = true;
// 设置请求拦截器,在请求头中添加csrftoken
/*
axios.interceptors.request.use(function (config) {
    if (((config.method==='post')|| (config.method==='POST')))
    {
        // 获取cookie中存储的csrftoken，并添加到请求头中
        // 因为cookie中还存储了其他数据，所以需要用split()函数分割，找到csrftoken所在的字符串，再用split()函数再次分割取出csrftoken的值
        const csrfToken = document.cookie.split('; ')
            .find(cookie => cookie.startsWith('csrftoken='));
        if (csrfToken) {
            // config.headers['Content-Type']='application/x-www-form-urlencoded'}
            // 设置请求数据格式为json
            config.headers['Content-Type']='application/json';
            config.headers['X-CSRFToken']=csrfToken.split('=')[1];
        }else{
            console.log('csrftoken not found in cookie')
            router.push('/403')
        }
    }else{
        const session_user = document.cookie.split('; ')
            .find(cookie => cookie.startsWith('session_user='));
        if (!session_user) {
            router.push('/login')
        }
    }
    return config;
}, function (error) {
    // Do something with request error
    return Promise.reject(error);
});
 */

//全局注册axios
app.config.globalProperties.$axios = axios;

// 允许跨域携带cookie
axios.defaults.withCredentials = true;



//使用路由和pinia
app.use(router)
app.use(pinia)
app.use(ElementPlus)
app.use(CKEditor)
app.mount('#app')
